import NavigateBackWizardStep from "../../components/navigateBackWizardStep";
import { useWizard } from "react-use-wizard";
import MultipleChoice from "../../components/multipleChoice";

function MultiChoiceStep({
  initState = null,
  onSubmitHandler,
  qKey,
  question,
  questionCode,
  choices,
  pageTitle,
  isPillView = false,
  nextConfig = null,
  hideLibrary = false,
}) {
  const { previousStep, nextStep, goToStep } = useWizard();

  const next = (choices) => {
    const response = {
      _state: choices,
      formatted_response: [
        {
          type: "MULTI",
          question: question,
          code: questionCode,
          choices: Object.keys(choices).map((key) => ({
            text: choices[key]["value"],
            correct: choices[key]["checked"],
            code: choices[key]["id"],
          })),
        },
      ],
    };
    onSubmitHandler({ [qKey]: response });
    return toJumpStep(choices) ? goToStep(nextConfig["nextStep"]) : nextStep();
  };

  const toJumpStep = (choices) => {
    if (nextConfig == null) return false;
    let optionCodes = Object.keys(choices);
    let match = false;
    for (let i = 0; i < optionCodes.length; i++) {
      if (optionCodes[i] === nextConfig["optionCode"]) {
        match = true;
        break;
      }
    }
    return match;
  };

  return (
    <>
      <NavigateBackWizardStep
        clickHandler={previousStep}
        title={pageTitle}
        hideLibrary={hideLibrary}
      />
      <div className="body_content">
        <div className="inner_body">
          <MultipleChoice
            question={question}
            choices={choices}
            qKey={qKey}
            selectedChoices={initState || {}}
            onSubmitHandler={next}
            isPillView={isPillView}
          />
        </div>
      </div>
    </>
  );
}

export default MultiChoiceStep;
